<template>
  <div
    class="w-full p-5 text-center flex flex-col items-center justify-center gap-5"
  >
    <div>
      <div class="text-xl font-bold">{{ title }}</div>
      <div class="mt-1 text-sm text-muted-foreground">{{ description }}</div>
    </div>
    <div v-if="mode === 'face'" class="w-full">
      <Progress :model-value="progress" class="h-1.5" />
    </div>
  </div>
</template>

<script>
import { Progress } from "@/shared/ui/progress";

export default {
  name: "AppFaceIdProgress",
  components: { Progress },
  props: {
    step: { type: String, default: "right" },
    mode: { type: String, default: "face" },
  },
  computed: {
    progress() {
      switch (this.step) {
        case "right":
          return 0;
        case "left":
          return 20;
        case "straight":
          return 40;
        case "smile":
          return 60;
        case "done":
          return 80;
        case "finally_done":
          return 100;
      }
      return 0;
    },
    title() {
      if (this.mode === "qr") return this.$t("Просканируйте QR-код");
      return this.$t("Сканирование лица");
    },
    description() {
      if (this.mode === "qr") {
        return this.$t(
          "Просканируйте QR-код чтобы продолжить работу через мобильный телефон"
        );
      }
      return this.$t(
        "Система анализирует ваше лицо. Пожалуйста, держите лицо в центре рамки."
      );
    },
  },
};
</script>
